









import { Component, Prop, Vue } from 'vue-property-decorator';
import SurfaceOn from "./resources/surfaceOn.vue";
import SurfaceOff from "./resources/surfaceOff.vue";
import BackOn from "./resources/backOn.vue";
import BackOff from "./resources/backOff.vue";
// import RightButton from "./resources/rightButton.vue";

import { Document } from "@/model/document2/document";

@Component({
  components: {
      SurfaceOn,
      SurfaceOff,
      BackOn,
      BackOff
  },
})
export default class DisplayController extends Vue
{
    private get currentDocument(): Document 
    {
        return this.$store.getters.document;
    }

    private get hasReverse() { return this.currentDocument.hasReverseSurface; }

    private get isReverse() {  return this.currentDocument.isReverseSurface; }

    private changeSurface()
    {
        this.$emit("doCommand", "changeSurface", { isReverse: !this.currentDocument.isReverseSurface });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
